import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DynamicSvg, getTestId, GradientView, Typography, useBreakpoint, WHITE } from '@airtel/air-design-system';
import { View } from 'react-native';
import { Offer } from './components/offer/Offer';
import { SocialProof } from './components/social-proof/SocialProof';
import { getOfferStripWidgetStyles } from './OfferStripWidgetStyles';
export var OfferStripWidgetComponent = props => {
  var _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'OfferStripWidget' : _props$testID,
    text = props.text,
    boldText = props.boldText,
    _props$type = props.type,
    type = _props$type === void 0 ? 'offer' : _props$type,
    _props$iconType = props.iconType,
    iconType = _props$iconType === void 0 ? type : _props$iconType,
    _props$iconProps = props.iconProps,
    iconProps = _props$iconProps === void 0 ? {} : _props$iconProps,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'under-card' : _props$variant,
    _props$iconName = props.iconName,
    iconName = _props$iconName === void 0 ? 'MultipleUsersIcon' : _props$iconName,
    _props$multiText = props.multiText,
    multiText = _props$multiText === void 0 ? [] : _props$multiText,
    style = props.style,
    inCardContainerStyle = props.inCardContainerStyle;
  var OfferStripWidgetStyles = getOfferStripWidgetStyles(props);
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var GradientViewChildren = () => {
    return _jsxs(GradientView, Object.assign({
      type: type === 'social-proof' ? 'STELLAR' : 'MANTLE',
      style: [OfferStripWidgetStyles.innerContainer, variant === 'in-card' && inCardContainerStyle]
    }, {
      children: [_jsxs(View, Object.assign({
        style: OfferStripWidgetStyles.iconContainer
      }, {
        children: [iconType === 'offer' && _jsx(Offer, {}), iconType === 'social-proof' && _jsx(SocialProof, {}), _jsx(DynamicSvg, Object.assign({
          iconName: iconName,
          fontSize: 16,
          color: WHITE,
          style: iconType !== 'logo' && OfferStripWidgetStyles.offerIcon
        }, iconProps, getTestId(testID, 'icon')))]
      })), _jsx(View, Object.assign({
        style: OfferStripWidgetStyles.text
      }, {
        children: _jsx(Typography, Object.assign({
          multiText: [{
            text: text
          }, Object.assign({}, boldText && {
            text: ' ' + boldText,
            isBold: true
          }), ...multiText],
          type: "body-para-" + (isLargeScreen ? 'sm' : 'xs')
        }, getTestId(testID, 'text')))
      }))]
    }));
  };
  return _jsx(_Fragment, {
    children: (!!text || !!boldText || !!(multiText === null || multiText === void 0 ? void 0 : multiText.length)) && _jsxs(_Fragment, {
      children: [variant === 'under-card' && _jsx(GradientView, Object.assign({}, getTestId(testID), {
        style: [OfferStripWidgetStyles.container, style],
        type: type === 'social-proof' ? 'DODGER_BLUE' : 'RETRO'
      }, {
        children: _jsx(GradientViewChildren, Object.assign({}, getTestId(testID, 'underCardChildren')))
      })), variant === 'in-card' && _jsx(GradientViewChildren, Object.assign({}, getTestId(testID, 'inCardChildren')))]
    })
  });
};
OfferStripWidgetComponent.genericRendererKey = 'AirOfferStripWidget';